"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderAgainRestaurantsResponseToJSON = exports.GetOrderAgainRestaurantsResponseFromJSONTyped = exports.GetOrderAgainRestaurantsResponseFromJSON = void 0;
var _1 = require("./");
function GetOrderAgainRestaurantsResponseFromJSON(json) {
    return GetOrderAgainRestaurantsResponseFromJSONTyped(json, false);
}
exports.GetOrderAgainRestaurantsResponseFromJSON = GetOrderAgainRestaurantsResponseFromJSON;
function GetOrderAgainRestaurantsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'restaurants': (json['restaurants'].map(_1.RestaurantSearchResultFromJSON)),
    };
}
exports.GetOrderAgainRestaurantsResponseFromJSONTyped = GetOrderAgainRestaurantsResponseFromJSONTyped;
function GetOrderAgainRestaurantsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'restaurants': (value.restaurants.map(_1.RestaurantSearchResultToJSON)),
    };
}
exports.GetOrderAgainRestaurantsResponseToJSON = GetOrderAgainRestaurantsResponseToJSON;
